module.exports = __webpack_public_path__ + "static/img/setting.6d5c6986.svg";